import logo from './redIcon.png';
import './App.css';
import React from "react";

import { storage } from "./firebase";
import { useState, useEffect, useRef } from 'react';
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

const TagSelectButton = React.forwardRef((props, ref) => {
  const [color, setColor] = useState("w");
  function toggle() {
    if (checkTags(props.all).length < 2 || color === "g") {
      if (color === "w") setColor("g");
      else setColor("w");
    }
  }
  if (color === "g") return <button onClick={toggle} id={props.tag} ref={ref} className="bg-ddg mt-4 px-6 py-1 text-sm rounded-lg">{props.tag}</button>;
  else return <button onClick={toggle} id={props.tag} ref={ref} className="bg-darkgr mt-4 px-6 py-1 text-sm rounded-lg">{props.tag}</button>;
});

const StatusSelectButton = React.forwardRef((props, ref) => {
  const [color, setColor] = useState("d"); // D = dark, B = bright
  function toggle() {
    if (checkStatus(props.all).length < 1 || color === "b") {
      if (color === "d") setColor("b");
      else setColor("d");
    }
  }
  if (props.status === "Complete") {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddc mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddc mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  } else if (props.status === "Demo") {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddy mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddy mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  } else {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddo mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddo mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  }
});

const JobSelectButton = React.forwardRef((props, ref) => {
  const [color, setColor] = useState("d"); // D = dark, B = bright
  function toggle() {
    if (checkJobs(props.all).length < 1 || color === "b") {
      if (color === "d") setColor("b");
      else setColor("d");
    }
  }
  if (color === "d") return <button onClick={toggle} id={props.job} ref={ref} className="bg-darkgr mt-4 px-4 md:px-6 py-1 text-sm rounded-lg">{props.jobName}</button>;
  else return <button onClick={toggle} id={props.job} ref={ref} className="bg-darkgo mt-4 px-4 md:px-6 py-1 text-sm rounded-lg">{props.jobName}</button>;
});

function checkTags(all) {
  let selected = [];
  all.forEach(tag => {
    if (tag.current.className[4] === "d") selected.push(tag.current.id);
  });
  return selected;
}

function checkStatus(all) {
  let selected = [];
  all.forEach(tag => {
    if (tag.current.className[5] !== "d") selected.push(tag.current.id);
  });
  return selected;
}

function checkJobs(all) {
  let selected = [];
  all.forEach(tag => {
    if (tag.current.className[8] === "o") selected.push(tag.current.id);
  });
  return selected;
}

function TagButton(props) {
  if (!props.tag) return <div></div>;
  else {
    return (
      <button className="bg-ddg mt-5 px-6 py-1 rounded-lg text-base">{props.tag}</button>
    )
  }
}

function StatusButton(props) {
  let button;
  if (props.color === "ddc") button = <button className="bg-ddc mt-5 px-6 py-1 rounded-lg text-base">{props.status}</button>;
  else if (props.color === "ddy") button = <button className="bg-ddy mt-5 px-6 py-1 rounded-lg text-base">{props.status}</button>;
  else button = <button className="bg-ddo mt-5 px-6 py-1 rounded-lg text-base">{props.status}</button>;
  return button;
}

function ReturnWorldPackPreview(title, author, desc, allTag, allStat, SetPackPreview) {
  let status = checkStatus(allStat);
  let statusButton;
  if (status.length > 0) status = status[0];
  if (status === "Complete") statusButton = <StatusButton color="ddc" status={status}/>;
  else if (status === "Demo") statusButton = <StatusButton color="ddy" status={status}/>;
  else if (status === "Beta") statusButton = <StatusButton color="ddo" status={status}/>;
  else statusButton = <div></div>;

  let tags = checkTags(allTag);
  let tagSection;
  if (tags.length > 0) tagSection = <div className="grid grid-cols-1 grid-rows-2 xl:grid-cols-2 xl:grid-rows-1 xl:gap-3">
    <TagButton tag={tags[0]}/>
    <TagButton tag={tags[1]}/>
  </div>;
  else tagSection = <div></div>;
  let packTitle = title.current.value;
  let packCreator = author.current.value;
  if (packTitle === "") packTitle = "No pack name";
  if (packCreator === "") packCreator = "no creator";
  SetPackPreview(
  <div>
    <div className="flex justify-center">
      <button onClick={() => ReturnWorldPackPreview(
        title,
        author,
        desc,
        allTag,
        allStat,
        SetPackPreview
      )} className="bg-darkc hover:bg-ddc transition duration-50 mt-5 mb-5 px-12 py-2 rounded-lg text-base">Reload</button>
    </div>
    <div className="bg-darkg px-6 md:px-8 lg:px-12 xl:px-14 pt-12 pb-12 rounded-2xl text-center">
      <p className="text-xl md:text-2xl lg:text-3xl font-bold">{packTitle}</p>
      <p className="text-sm md:text-md lg:text-xl">By: {packCreator}</p>
      <p className="text-sm mt-3">{desc.current.value}</p>
      <button className="bg-darkc hover:bg-ddc transition duration-50 mt-5 mb-5 px-12 py-2 rounded-lg text-base">View</button>
      <hr/>
      {tagSection}
      {statusButton}
    </div>
  </div>);
}

function WorldPackPreview(props) {
  const [packPreview, setPackPreview] = useState(null);

  if (!packPreview) setPackPreview(<button onClick={() => ReturnWorldPackPreview(
    props.title, 
    props.author, 
    props.desc, 
    props.allTag, 
    props.allStat, 
    setPackPreview
  )} className="bg-darkc hover:bg-ddc transition duration-50 mt-5 mb-5 px-12 py-2 rounded-lg text-base">View</button>);

  return packPreview;
}

function ReturnVersionPreview(name, desc, SetVersionPreview) {
  let versionName = name.current.value;
  if (versionName === "") versionName = "No version name";
  SetVersionPreview(
  <div>
    <div className="flex justify-center">
      <button onClick={() => ReturnVersionPreview(
        name,
        desc,
        SetVersionPreview
      )} className="bg-darkc hover:bg-ddc transition duration-50 mt-5 mb-5 px-12 py-2 rounded-lg text-base">Reload</button>
    </div>
    <div className="bg-ddg px-5 py-5 mt-5 rounded-lg">
      <p className="text-xl ml-5 fontTitle">{versionName}</p>
      <p className="text-sm ml-5 lg:text-base xl:mr-80">{desc.current.value}</p>
      <button className="bg-darkc ml-5 hover:bg-ddc transition duration-50 px-5 py-3 mt-2 rounded-lg text-base">Download</button>
    </div>
  </div>);
}

function Version(props) {
  const [versionPreview, setVersionPreview] = useState(null);

  if (!versionPreview) setVersionPreview(<button onClick={() => ReturnVersionPreview(
    props.name,
    props.desc,
    setVersionPreview
  )} className="bg-darkc hover:bg-ddc transition duration-50 mt-5 mb-5 px-12 py-2 rounded-lg text-base">View</button>);

  return versionPreview;
}

async function submitForm(refs, allJobs, allTags, allStatus, setSubmitText) {
  let job = checkJobs(allJobs)[0];
  let packName = refs.name.current.value;
  let packCreator = refs.author.current.value;
  let packDesc = refs.desc.current.value;
  let packLong = refs.long.current.value;
  let packTags = checkTags(allTags);
  let packStatus = checkStatus(allStatus)[0];
  let versionName = refs.versionName.current.value;
  let versionDesc = refs.versionDesc.current.value;
  let versionFile = refs.versionFile.current.files[0];
  let bannerFile = refs.banner.current.files[0];

  let fileURL = "none";
  let bannerURL = "none";

  function setRef(value) {
    setSubmitText(<p className="text-base text-center mt-3">{value}</p>)
  }

  setRef("Submitting, please wait...");

  if (!job) return setRef("Please choose what you are attempting to do. (updating a pack or adding a version)");
  if (packName === "") return setRef("Please fill out the Name field. (You need a name for your pack!)");
  if (packCreator === "") return setRef("Please fill out the Creator field. (Who are you?)");
  if (!packStatus) return setRef("Please choose your pack's status. (is your pack complete, a demo, or a beta?)");

  if (versionFile) {
    let name = versionFile.name;
    let versionRef = ref(storage, `Packs/${name}`);
    await uploadBytes(versionRef, versionFile);
    let url = await getDownloadURL(versionRef);
    fileURL = url;
  }

  if (bannerFile) {
    const bannerRef = ref(storage, `Images/${bannerFile.name}`);
    await uploadBytes(bannerRef, bannerFile);
    let url = await getDownloadURL(bannerRef);
    bannerURL = url;
  }

  const content = {
    "content": `New submission: ${job}`,
    "embeds": [{
      "title": packName,
      "description": `Pack Creator: ${packCreator}\nPack Description: ${packDesc}\n\nLong Description: ${packLong}\n\n
      Tags: ${packTags.toString()}\nStatus: ${packStatus}\n\nVersion Name: ${versionName}\nVersion Desc: ${versionDesc}
      \n\nFile URL: ${fileURL}\nBanner URL: ${bannerURL}`
    }]
  };

  fetch("https://discord.com/api/webhooks/1046540026378461306/_4X6I6sZTPYvHb7y0Q1WxZlQ4BMy6GgdJeahtjLwUS-cxk5bm8XdIudkHGaEAunpYwgq", {
    method: "POST",
    body: JSON.stringify(content),
    headers: {
      "Content-Type": "application/json"
    }
  });

  if (job === "Update") setRef("Pack update request sent.");
  if (job === "Version") setRef("Version submitted successfully.");
}

function Home() {

  const packName = useRef(null);
  const packDesc = useRef(null);
  const packLong = useRef(null);
  const packAuthor = useRef(null);

  const versionName = useRef(null);
  const versionDesc = useRef(null);
  const versionFile = useRef(null);

  const bannerFile = useRef(null);

  const jobUpdate = useRef(null);
  const jobVersion = useRef(null);

  let allJobs = [jobUpdate, jobVersion];
  
  const tagTraditional = useRef(null);
  const tagStory = useRef(null);
  const tagDifficult = useRef(null);
  const tagKaizo = useRef(null);
  const tagSequel = useRef(null);
  const tagDecoration = useRef(null);
  const tagGimmick = useRef(null);
  const tagFriends = useRef(null);
  const tagAbility = useRef(null);
  const tagPurple = useRef(null);

  let allTags = [tagTraditional, tagStory, tagDifficult, tagKaizo, tagSequel, tagDecoration, tagGimmick, tagFriends, tagAbility, tagPurple];

  const statusComplete = useRef(null);
  const statusDemo = useRef(null);
  const statusBeta = useRef(null);

  let allStatus = [statusComplete, statusDemo, statusBeta];

  const [submitText, setSubmitText] = useState(<p className="text-base text-center mt-3"></p>);

  /*const [login, setLogin] = useState(false);
  useEffect(() => {
      onAuthStateChanged(auth, (user) => {
          if (user) {
              setLogin(true);
          } else {
              setLogin(false);
          }
      });
  });

  if (!login) return(<div className="App bg-gradient-to-br from-ddp to-darkp min-h-screen">
    <header className="ml-4 md:ml-12 lg:ml-20 pt-32">
      <p className="fontTitle text-md">
        Please login or sign up to submit a pack.
      </p>
      <button onClick={() => window.location.replace("/signin")} className="bg-darkg hover:bg-ddg transition duration-50 px-16 py-2 mt-5 rounded-lg text-lg font-bold">Sign In</button>
    </header>
  </div>);*/

  return(<div className="App bg-gradient-to-br from-ddp to-darkp">
    <header className="ml-4 md:ml-12 lg:ml-20 pt-32">
      <img src={logo} className="App-logo" alt="logo" />
      <p className="fontTitle text-2xl md:text-4xl lg:text-6xl">
        Submit a Pack:
      </p>
    </header>
    <div className="mt-4 ml-4 md:ml-12 lg:ml-20">
      <p className="text-base md:text-xl mr-10 md:mr-16">Pack submissions are closed since May 1st. Thank you to everyone who submitted packs!</p>
      <p className="text-base md:text-xl mr-10 md:mr-16">You may still update a pack you've already submitted. Please note that <b>packs can take up to 96 hours</b> to be updated.</p><br/>
    </div>
    <div className="mt-16 mb-10 grid grid-cols-1 grid-rows-2 md:grid-cols-2 md:grid-rows-1">
      <div className="">
        <p className="text-center text-xl md:text-3xl lg:text-4xl fontTitle">Information:</p><br/>
        <div className="ml-4 md:ml-12 lg:ml-24">
          <div className="">
            <p className="text-lg">What do you want to do?</p>
            <div className="grid grid-rows-3 grid-cols-1 md:grid-rows-1 md:grid-cols-3 gap-1 mx-16 md:ml-0 md:mx-0">
              <JobSelectButton job="Update" jobName="Update a pack" ref={jobUpdate} all={allJobs}/>
              <JobSelectButton job="Version" jobName="Add a new version" ref={jobVersion} all={allJobs}/>
            </div>
            <p className="text-base mt-3 mr-10">When updating a pack or version, only enter in fields that you wish to update.</p>
            <p className="text-base mr-5">Name, Status, and Creator are required fields.</p>
          </div>
          <div className="mt-5">
            <p className="text-lg">Pack Name:</p>
            <input type="text" placeholder="" ref={packName} maxLength="100" className="w-5/6 md:w-3/4 lg:w-2/3 text-black text-base"></input>
          </div>
          <div className="mt-5">
            <p className="text-lg">Pack Description: (200 character limit)</p>
            <textarea type="text" ref={packDesc} placeholder="" maxLength="200" className="w-5/6 md:w-3/4 lg:w-2/3 h-16 text-black text-base"></textarea>
          </div>
          <div className="mt-5">
            <p className="text-lg">Long Pack Description: (appears on pack page)</p>
            <textarea type="text" ref={packLong} placeholder="" className="w-5/6 md:w-3/4 lg:w-2/3 h-24 text-black text-base"></textarea>
          </div>
          <div className="mt-5">
            <p className="text-lg">Tags: (up to 2)</p>
            <div className="grid grid-rows-5 grid-cols-2 md:grid-rows-2 md:grid-cols-5 gap-1 mx-2 md:mx-0 -ml-2">
                <TagSelectButton tag="Traditional" ref={tagTraditional} all={allTags}/>
                <TagSelectButton tag="Story" ref={tagStory} all={allTags}/>
                <TagSelectButton tag="Difficult" ref={tagDifficult} all={allTags}/>
                <TagSelectButton tag="Sequel" ref={tagSequel} all={allTags}/>
                <TagSelectButton tag="Kaizo" ref={tagKaizo} all={allTags}/>
                <TagSelectButton tag="Gimmick" ref={tagGimmick} all={allTags}/>
                <TagSelectButton tag="Decoration" ref={tagDecoration} all={allTags}/>
                <TagSelectButton tag="Friends" ref={tagFriends} all={allTags}/>
                <TagSelectButton tag="Ability" ref={tagAbility} all={allTags}/>
                <TagSelectButton tag="Purple" ref={tagPurple} all={allTags}/>
            </div>
            <p className="text-base mt-3">Selecting 2 tags for your pack is highly recommended.</p>
          </div>
          <div className="mt-8">
            <p className="text-lg">Status:</p>
            <div className="grid grid-rows-1 grid-cols-3 gap-1">
              <StatusSelectButton status="Complete" ref={statusComplete} all={allStatus}/>
              <StatusSelectButton status="Demo" ref={statusDemo} all={allStatus}/>
              <StatusSelectButton status="Beta" ref={statusBeta} all={allStatus}/>
            </div>
            <p className="text-base mt-3 mr-16"><b>Complete</b> packs are finished, though they may receive small updates from time to time.</p>
            <p className="text-base mr-5"><b>Demos</b> have a good amount of content already, but are not finished yet.</p>
            <p className="text-base mr-5"><b>Betas</b> are only the first world or few rooms of a pack.</p>
          </div>
          <div className="mt-5 px-5 py-5 bg-ddg rounded-md">
            <p className="text-2xl">Version Info</p>
            <p className="text-base">Each "version" of your pack has its own name, short description, and file.</p>
            <p className="text-base">For example, one pack could have one "normal" version and one "difficult" version.</p>
            <div className="mt-5">
              <p className="text-lg">Version Name:</p>
              <input type="text" placeholder="" ref={versionName} maxLength="100" className="w-5/6 md:w-3/4 lg:w-2/3 text-black text-base"></input>
              <p className="text-base">If this is your first time uploading this pack, just put in your pack's name.</p>
            </div>
            <div className="mt-5">
              <p className="text-lg">Version Description: (brief description of version - optional)</p>
              <input type="text" placeholder="" ref={versionDesc} maxLength="200" className="w-5/6 md:w-3/4 lg:w-2/3 text-black text-base"></input>
            </div>
            <div className="mt-5">
              <p className="text-lg">Version File: (.worldpack file)</p>
              <input type="file" ref={versionFile} className="text-sm" accept=".worldpack"></input>
            </div>
          </div>
          <div className="mt-5">
            <p className="text-lg">Banner: (optional)</p>
            <p className="text-base">Your banner appears at the top of your pack page.</p>
            <p className="text-base">The suggested size for banners is 1920 x 360 px, but any banner with a 1920px length or a 16:3 ratio will be accepted.</p>
            <input type="file" placeholder="" ref={bannerFile} maxLength="100" className="text-sm"></input>
          </div>
          <div className="mt-5">
            <p className="text-lg">Creator: (you!)</p>
            <input type="text" ref={packAuthor} placeholder="" maxLength="100" className="w-5/6 md:w-3/4 lg:w-2/3 text-black text-base"></input>
          </div>
        </div>
      </div>
      <div>
        <p className="text-center text-xl md:text-3xl lg:text-4xl fontTitle mt-10 md:mt-0">Previews:</p><br/>
        <p className="text-center text-lg md:text-xl">In search:</p>
        <div className="flex justify-center mx-12 lg:mx-36">
          <WorldPackPreview title={packName} desc={packDesc} author={packAuthor} allTag={allTags} allStat={allStatus}/>
        </div>
        <p className="text-center text-lg md:text-xl mt-10">Current version:</p>
        <div className="flex justify-center mx-1 lg:mx-12">
          <Version name={versionName} desc={versionDesc}/>
        </div>
        <div className="visible md:invisible mt-10 mx-6">
          <div className="flex justify-center">
            <button onClick={() => submitForm({
              name: packName,
              author: packAuthor,
              desc: packDesc,
              long: packLong,
              versionName: versionName,
              versionDesc: versionDesc,
              versionFile: versionFile,
              banner: bannerFile
            }, allJobs, allTags, allStatus, setSubmitText)} className="bg-darkgo hover:bg-ddgo transition duration-50 px-16 py-3 rounded-lg text-lg font-bold">Submit!</button>
          </div>
          {submitText}
        </div>
      </div>
    </div>
    <div className="invisible md:visible">
      <div className="flex justify-center">
        <button onClick={() => submitForm({
          name: packName,
          author: packAuthor,
          desc: packDesc,
          long: packLong,
          versionName: versionName,
          versionDesc: versionDesc,
          versionFile: versionFile,
          banner: bannerFile
        }, allJobs, allTags, allStatus, setSubmitText)} className="bg-darkgo hover:bg-ddgo transition duration-50 px-16 py-3 rounded-lg text-lg font-bold">Submit!</button>
      </div>
      {submitText}
      <br/>
    </div>
  </div>);
}

// <WorldPackPreview title={packName.current.value} desc={packDesc.current.value} author={packAuthor.current.value} allTag={allTags} allStat={allStatus}/>
          
export default Home;